/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../tslib.es6-e01eabb2.js';
import { L as index$a } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import showToast$1 from './dingTalk/index.js';
import showToast$2 from './cn/index.js';
import ali1688 from './ali1688/index.js';
import showToast$3 from './panguMiniApp/index.js';
import mini from './mini/index.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';
import '../../index-48bf95da.js';

var extendShowToast = extend({
    web: {
        dingTalk: showToast$1,
        dingTalkPC: showToast$1,
        windvane: {
            cn: showToast$2,
            ali1688: ali1688,
        },
    },
    mini: mini,
    panguMiniApp: showToast$3,
}, 
/** baseShowToast 支持windvane容器、nebula容器、小程序容器 */
index$a);
/**
 * toast 提示
 * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
 * @param  {string|ShowToastIOptions} [data] toast文案
 * @returns {Promise<unknown>} promise调用结果
 * @example 使用案例：
 * import { showToast } from '@alife/cn-uni-api'; // h5、小程序通用包
 *
 * showToast({
 *  content: '提示内容',
 *  duration: 2000,
 * })
 *   .then(() => {
 *     console.log('success');
 *   })
 *   .catch((error) => {
 *     console.log(error);
 *   });
 * @author 敬文
 */
var showToast = function (data) {
    if (typeof data === 'string') {
        return extendShowToast({ content: data, duration: 2000 });
    }
    return extendShowToast(__assign({ duration: 2000 }, data));
};

export { showToast };
